import {
    CodeBlock,
    BlockType,
    SettingType,
    ValidationMessage,
    ValidationMessageType,
    TibboDataType,
    IOLinesMode,
    IOMode,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import IOTibbit from '@appblocks/codegeneration/Tibbits/_IOTibbit';

export default class Tibbit_04_5 extends IOTibbit {
    constructor() {
        super();
        this.id = 'tibbit_04_5';
        this.name = 'Tibbit 04_5';
        this.lines = 2;
        this.mode = IOMode.INPUT;
        this.initLines();
    }
}
